export enum Location {
	Top = 'top',
	Right = 'right',
	Bottom = 'bottom',
	Left = 'left',
}
